import React from "react";

function Footer(props) {
    return (
        <footer className="footer">
            <div className="footer-content">
                <span className="footer-text">QRC<span className="footer-text-green">B</span><span className="footer-text-yellow">R</span></span>
                <span className="footer-text-min">A solução mais completa de Qr Code</span>
            </div>
        </footer>
    );
}

export default Footer;